import AuraFXPage from "@/components/AuraFXPage";

const AuraGBPUSD = () => {
  return (
    <AuraFXPage 
      instrument="GBPUSD" 
      name="GBP/USD" 
      apiPath="/aura/gbpusd" 
    />
  );
};

export default AuraGBPUSD;
